import styled from '@emotion/styled';

import { breakpoint, spacing } from 'component-library';

export const AddContainerWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xsmall};
`;

export const MaterialAndImageWrapper = styled('div')`
  display: flex;
  gap: ${spacing.small};

  @media (max-width: ${breakpoint.medium}px) {
    flex-wrap: wrap;
  }
`;

export const ContainerImageWrapper = styled.div`
  padding: ${spacing.mediumLow};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MaterialWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${spacing.small};
  flex-grow: 2;
`;

export const AmountAndDateWrapper = styled('div')<{ stackDate?: boolean }>`
  display: flex;
  flex-wrap: ${({ stackDate }) => (stackDate ? 'wrap' : 'nowrap')};
  gap: ${spacing.small};

  @media (max-width: ${breakpoint.medium}px) {
    flex-wrap: wrap;
  }
`;

export const DateWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  direction: row;
  justify-content: flex-end;
  gap: ${spacing.small};
  margin-top: ${spacing.small};
`;

export const DatePickerWrapper = styled.div<{ fullWidth?: boolean }>`
  flex-grow: 1;
  flex-basis: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
`;
export const AmountWrapper = styled.div`
  flex-grow: 1;
`;
